(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SOURCE_KEY_PROPERTY = '_cross_sell_source_key';
  const ORIGIN_HANDLE_PROPERTY = '_cross_sell_origin_handle';
  const OFFER_PAIR_PROPERTY = '_cross_sell_offer_pair';

  const PAIRS = {
    'etiquettes-personnalisees': {
      targetHandle: 'etiquettes-autocollantes-personnalisables',
      shortTitle: 'Autocollantes pour objets',
      offerLabel: 'Ajouter les autocollants assortis',
      badge: 'Réduction duo',
      defaultProperties: { Forme: 'Rectangle' },
      dropProperties: [],
    },
    'etiquettes-autocollantes-personnalisables': {
      targetHandle: 'etiquettes-personnalisees',
      shortTitle: 'Thermocollantes pour vêtements',
      offerLabel: 'Ajouter les thermocollants assortis',
      badge: 'Réduction duo',
      defaultProperties: {},
      dropProperties: ['Forme', 'Deuxième ligne'],
    },
  };

  class PrintMyNameCrossSell {
    constructor() {
      this.productCache = new Map();
      this.unsubscribe = null;
      this.isRendering = false;
      this.lastAddedItemKey = null; // clé de l'article qui vient d'être ajouté au panier
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    init() {
      document.addEventListener('click', this.handleDocumentClick);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.source === 'cart-cross-sell') {
            // L'offre vient d'être acceptée : la marquer comme ajoutée
            this.markOfferAsAdded();
            return;
          }

          document.querySelectorAll('.cart-notification-product--appended, hr[style*="margin: 0"]').forEach(el => el.remove());

          // Mémoriser la clé de l'item qui vient d'être ajouté pour prioriser la bonne ligne source
          const cartData = event && event.cartData;
          const addedKey = (cartData && cartData.key) || null;
          if (!addedKey) {
            this.lastAddedItemKey = null;
            this.hideCrossSell();
            return;
          }

          this.lastAddedItemKey = addedKey;

          setTimeout(() => this.render(), 160);
        });
      }

      this.render();

      document.addEventListener('cart-notification:opened', (event) => {
        if (event && event.detail && event.detail.source === 'cart-cross-sell') {
          // Notification rouverte après un ajout cross-sell : la marquer comme ajoutée
          this.markOfferAsAdded();
          return;
        }

        document.querySelectorAll('.cart-notification-product--appended, hr[style*="margin: 0"]').forEach(el => el.remove());

        // Dawn peut transmettre la clé de l'article dans l'événement d'ouverture
        const eventKey = event && event.detail && event.detail.key;
        if (!eventKey) {
          this.hideCrossSell();
          return;
        }

        this.lastAddedItemKey = eventKey;

        setTimeout(() => this.render(), 60);
      });
    }

    /* ── DOM element getters ── */

    /** Cross-sell card within the duo grid (cart-notification) */
    get crossSellCard() {
      return document.querySelector('[data-cross-sell-card]');
    }

    /** CTA button zone below the duo grid (cart-notification) */
    get crossSellCta() {
      return document.querySelector('[data-cross-sell-cta]');
    }

    /** Colonne de l'offre duo (carte + bouton) */
    get duoContainer() {
      return document.querySelector('[data-cross-sell-wrap]');
    }

    /** Legacy container for the cart drawer (unchanged) */
    get container() {
      return document.querySelector('[data-cross-sell-container]');
    }

    get cartUiHost() {
      return document.querySelector('cart-drawer, cart-notification');
    }

    get divider() {
      return document.querySelector('[data-cross-sell-divider]');
    }

    /* ── Hide/Show helpers ── */

    hideCrossSell() {
      const card = this.crossSellCard;
      const cta = this.crossSellCta;
      const duo = this.duoContainer;
      if (card) { card.innerHTML = ''; }
      if (cta) { cta.hidden = true; }
      if (duo) duo.hidden = true;
      this.clearAddedCardDiscount();

      // Also hide legacy container (cart drawer)
      const container = this.container;
      if (container) { container.hidden = true; container.innerHTML = ''; }
      const divider = this.divider;
      if (divider) divider.hidden = true;
    }

    showCrossSell() {
      const card = this.crossSellCard;
      const cta = this.crossSellCta;
      const duo = this.duoContainer;
      if (card) card.hidden = false;
      if (cta) cta.hidden = false;
      if (duo) duo.hidden = false;
    }

    markOfferAsAdded() {
      const cta = this.crossSellCta;
      if (cta) cta.hidden = true;

      const card = this.crossSellCard;
      if (card) {
        card.classList.add('is-added');
        const badge = card.querySelector('.pmn-cn-offer__badge');
        if (badge) badge.textContent = '✓ Ajouté';
        const kicker = card.querySelector('.pmn-cn-offer__kicker');
        if (kicker) kicker.textContent = 'Le duo est dans votre panier';
      }

      // Legacy container update (cart drawer si besoin)
      const container = this.container;
      if (container) {
         const legacyBadge = container.querySelector('.cart-drawer__offer-badge');
         if (legacyBadge) {
           legacyBadge.className = 'cart-notification__duo-badge cart-notification__duo-badge--added';
           legacyBadge.innerHTML = 'Ajouté';
         }
         const legacyActions = container.querySelector('.cart-drawer__offer-actions');
         if (legacyActions) legacyActions.hidden = true;
      }

      // Le paiement redevient le bouton principal
      const checkoutButton = document.querySelector('#cart-notification .button--checkout');
      if (checkoutButton) checkoutButton.classList.add('button--checkout-success');

      // La réduction est acquise : on retire la phrase qui la conditionnait
      document.querySelectorAll('#cart-notification-product .pmn-cn-item__price-note').forEach((el) => el.remove());
    }

    /* ── Prix de l'article ajouté : réduction duo quand la source est autocollante ── */

    clearAddedCardDiscount() {
      const price = document.querySelector('#cart-notification-product [data-pmn-cn-price]');
      if (price && price.dataset.original) {
        price.innerHTML = price.dataset.original;
        delete price.dataset.original;
      }
    }

    updateAddedCardWithDiscount(offer) {
      this.clearAddedCardDiscount();
      const { sourceLine } = offer;
      if (this.getLineHandle(sourceLine) !== 'etiquettes-autocollantes-personnalisables') return;

      const discountPct = this.getDiscountPercentage(this.extractQuantity(sourceLine.variant_title));
      if (discountPct <= 0) return;

      const price = document.querySelector('#cart-notification-product [data-pmn-cn-price]');
      if (!price) return;

      const autoPrice = sourceLine.original_line_price || sourceLine.price || 0;
      const discountedPrice = Math.max(0, autoPrice - Math.round((autoPrice * discountPct) / 100));
      price.dataset.original = price.innerHTML;
      price.innerHTML = `<s>${this.formatMoney(autoPrice)}</s><span class="pmn-cn-promo">${this.formatMoney(discountedPrice)}</span><span class="pmn-cn-offer__pct">-${discountPct}%</span><span class="pmn-cn-item__price-note">Avec les thermocollants assortis</span>`;
    }

    /* ── Render ── */

    async render() {
      if (this.isRendering) return;
      this.isRendering = true;

      try {
        const cart = await this.fetchCart();
        const offer = await this.buildOffer(cart);

        if (!offer) {
          this.hideCrossSell();
          return;
        }

        // Render into the duo card (cart-notification style)
        const card = this.crossSellCard;
        const cta = this.crossSellCta;

        if (card && cta) {
          card.innerHTML = this.renderDuoCardMarkup(offer);
          card.classList.remove('is-added');

          const ctaBtn = cta.querySelector('[data-cross-sell-add]');
          if (ctaBtn) {
            ctaBtn.innerHTML = this.offerButtonLabel(offer);
            ctaBtn.dataset.sourceKey = offer.sourceLine.key;
            ctaBtn.disabled = false;
          }
          const errorNode = cta.querySelector('[data-cross-sell-error]');
          if (errorNode) { errorNode.hidden = true; errorNode.textContent = ''; }

          const checkoutButton = document.querySelector('#cart-notification .button--checkout') || document.querySelector('.cart-drawer__links .button--checkout');
          if (checkoutButton) {
            checkoutButton.classList.remove('button--checkout-success');
          }

          // Source autocollante : la réduction duo s'affiche sur le prix de l'article ajouté
          this.updateAddedCardWithDiscount(offer);

          this.showCrossSell();
        }

        // Also render into legacy container (for cart-drawer)
        const container = this.container;
        if (container) {
          container.hidden = false;
          container.innerHTML = this.renderLegacyMarkup(offer);
          const divider = this.divider;
          if (divider) divider.hidden = false;
        }
      } catch (error) {
        console.error('PrintMyName cross-sell render failed:', error);
      } finally {
        this.isRendering = false;
      }
    }

    /* ── Build offer ── */

    async buildOffer(cart) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return null;

      let sourceLine = null;
      const addedItemKey = this.lastAddedItemKey;

      // Priorité à l'item qui vient précisément d'être ajouté (clé mémorisée lors de l'événement)
      if (addedItemKey) {
        const addedItem = cart.items.find(item => item.key === addedItemKey);
        if (!addedItem || !this.isEligibleSourceLine(addedItem, cart)) return null;
        sourceLine = addedItem;
      }

      // Fallback : item éligible le plus récemment ajouté selon l'ordre du panier
      if (!sourceLine) {
        sourceLine = [...cart.items].reverse().find((item) => this.isEligibleSourceLine(item, cart));
      }

      if (!sourceLine) return null;

      const sourceHandle = this.getLineHandle(sourceLine);
      const pairConfig = PAIRS[sourceHandle];
      if (!pairConfig) return null;

      const targetProduct = await this.fetchProduct(pairConfig.targetHandle);
      const targetVariant = this.findBestVariantMatch(targetProduct, sourceLine);
      if (!targetVariant) return null;

      const missingQuantity = this.getMissingCrossSellQuantity(sourceLine, cart, pairConfig);

      return {
        sourceLine,
        sourceHandle,
        pairConfig,
        targetProduct,
        targetVariant,
        missingQuantity,
      };
    }

    getMissingCrossSellQuantity(item, cart, pairConfig) {
      const sourceQtyTotal = item.quantity || 1;
      let matchedTargetQty = 0;

      (cart.items || []).forEach((otherItem) => {
        if (this.getLineHandle(otherItem) !== pairConfig.targetHandle) return;

        const otherProps = otherItem.properties || {};
        if (otherProps[SOURCE_KEY_PROPERTY] === item.key) {
           matchedTargetQty += (otherItem.quantity || 1);
           return;
        }
        return;

        const props1 = item.properties || {};
        const props2 = otherProps;

        const checkKeys = ['Prénom Nom', 'Première ligne', 'Deuxième ligne', 'Emoji', 'Couleur d\'écriture', 'Police'];
        const dropProps = pairConfig.dropProperties || [];
        let allMatched = true;
        let anyPropChecked = false;

        checkKeys.forEach(k => {
          if (dropProps.includes(k)) return;

          if (props1[k] || props2[k]) {
            anyPropChecked = true;
            if (this.normalizeValue(props1[k]) !== this.normalizeValue(props2[k])) {
              allMatched = false;
            }
          }
        });

        if (!anyPropChecked && Object.keys(props1).length === 0) {
           matchedTargetQty += (otherItem.quantity || 1);
           return;
        }

        if (!anyPropChecked || !allMatched) return;

        const extractQty = (str) => { const m = String(str || '').match(/\d+/); return m ? m[0] : ''; };
        const rawSourceQty = extractQty(item.variant_title);
        const sourceQty = this.mapQuantityEquivalent(rawSourceQty);
        const otherQty = extractQty(otherItem.variant_title);

        if (sourceQty && otherQty && sourceQty !== otherQty) return;

        matchedTargetQty += (otherItem.quantity || 1);
      });

      return Math.max(0, sourceQtyTotal - matchedTargetQty);
    }

    isEligibleSourceLine(item, cart) {
      const handle = this.getLineHandle(item);
      const pairConfig = PAIRS[handle];
      if (!pairConfig) return false;

      const props = item.properties || {};
      if (props[SOURCE_KEY_PROPERTY]) return false;
      if (props[ORIGIN_HANDLE_PROPERTY]) return false;

      return this.getMissingCrossSellQuantity(item, cart, pairConfig) > 0;
    }

    getLineHandle(item) {
      if (item && item.handle) return item.handle;
      if (item && item.url && item.url.indexOf('/products/') !== -1) {
        return item.url.split('/products/')[1].split('?')[0].split('/')[0];
      }
      return '';
    }

    /* ── API calls ── */

    async fetchCart() {
      const response = await fetch(`${ROOT}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`Cart request failed with status ${response.status}`);
      }

      return response.json();
    }

    async fetchProduct(handle) {
      if (this.productCache.has(handle)) return this.productCache.get(handle);

      const response = await fetch(`${ROOT}products/${handle}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`Product request failed for ${handle}`);
      }

      const product = await response.json();
      this.productCache.set(handle, product);
      return product;
    }

    /* ── Helpers ── */

    normalizeValue(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    mapQuantityEquivalent(str) {
      if (!str) return str;
      return String(str).replace(/(^|\D)(120|140|160|180|200)(?=\D|$)/g, (match, prefix, numStr) => {
         const num = parseInt(numStr, 10);
         let mapped = '';
         if (num === 120) mapped = '100';
         else if (num === 140) mapped = '120';
         else if (num === 160) mapped = '140';
         else if (num === 180) mapped = '160';
         else if (num === 200) mapped = '180';
         return prefix + mapped;
      });
    }

    extractQuantity(str) {
      const match = String(str || '').match(/\d+/);
      return match ? match[0] : '';
    }

    getDiscountPercentage(rawSourceQtyStr) {
      const num = parseInt(this.extractQuantity(rawSourceQtyStr) || '10', 10);
      if (num === 30) return 15;
      if (num === 60 || num === 80 || num === 100) return 12;
      if (num >= 120) return 10;
      return 0;
    }

    extractSourceOptionValues(sourceLine) {
      if (Array.isArray(sourceLine.options_with_values) && sourceLine.options_with_values.length) {
        return sourceLine.options_with_values.map((option) => option.value).filter(Boolean);
      }

      if (Array.isArray(sourceLine.variant_options) && sourceLine.variant_options.length) {
        return sourceLine.variant_options.filter(Boolean);
      }

      if (sourceLine.variant_title && sourceLine.variant_title !== 'Default Title') {
        return sourceLine.variant_title.split(' / ').map((value) => value.trim()).filter(Boolean);
      }

      return [];
    }

    findBestVariantMatch(product, sourceLine) {
      const variants = (product.variants || []).filter((variant) => variant.available);
      if (!variants.length) return null;

      const rawSourceQty = this.extractQuantity(sourceLine.variant_title);
      const wantedQuantity = this.mapQuantityEquivalent(rawSourceQty);
      const quantityMatchedVariants = wantedQuantity
        ? variants.filter((variant) => {
            const values = [variant.title, variant.option1, variant.option2, variant.option3]
              .filter(Boolean)
              .map((value) => this.extractQuantity(value));
            return values.includes(wantedQuantity);
          })
        : variants;

      if (wantedQuantity && !quantityMatchedVariants.length) return null;

      const variantsToScore = quantityMatchedVariants.length ? quantityMatchedVariants : variants;
      const wantedValues = this.extractSourceOptionValues(sourceLine).map((value) => {
        let normalized = this.normalizeValue(value);
        return this.mapQuantityEquivalent(normalized);
      });
      const sourceVariantTitle = this.mapQuantityEquivalent(this.normalizeValue(sourceLine.variant_title));

      let bestVariant = variantsToScore[0];
      let bestScore = -1;

      variantsToScore.forEach((variant) => {
        const optionValues = [variant.option1, variant.option2, variant.option3]
          .filter(Boolean)
          .map((value) => this.normalizeValue(value));

        let score = 0;

        if (sourceVariantTitle && this.normalizeValue(variant.title) === sourceVariantTitle) {
          score += 100;
        }

        wantedValues.forEach((value) => {
          if (!value) return;
          
          // Heavy priority for numeric strings (like '60', '30') to ensure quantity matched
          const isNumeric = /^\d+$/.test(value) || (value.includes('x') && /^\d+x?$/.test(value));
          const matchWeight = isNumeric ? 50 : 10;
          const partialWeight = isNumeric ? 25 : 5;

          if (optionValues.includes(value)) {
            score += matchWeight;
            return;
          }

          if (optionValues.some((optionValue) => optionValue.includes(value) || value.includes(optionValue))) {
            score += partialWeight;
          }
        });

        if (score > bestScore) {
          bestScore = score;
          bestVariant = variant;
        }
      });

      return bestVariant;
    }

    shouldDropProperty(name, pairConfig) {
      const normalizedName = this.normalizeValue(name);
      return (pairConfig.dropProperties || []).some((propertyName) => this.normalizeValue(propertyName) === normalizedName);
    }

    hasProperty(properties, wantedName) {
      const wanted = this.normalizeValue(wantedName);
      return Object.keys(properties || {}).some((key) => this.normalizeValue(key) === wanted);
    }

    buildTargetProperties(sourceLine, pairConfig) {
      const sourceProperties = sourceLine.properties || {};
      const targetProperties = {};

      Object.entries(sourceProperties).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '' || String(key).startsWith('_')) return;
        if (this.shouldDropProperty(key, pairConfig)) return;
        targetProperties[key] = value;
      });

      Object.entries(pairConfig.defaultProperties || {}).forEach(([key, value]) => {
        if (!this.hasProperty(targetProperties, key)) {
          targetProperties[key] = value;
        }
      });

      targetProperties[SOURCE_KEY_PROPERTY] = sourceLine.key;
      targetProperties[ORIGIN_HANDLE_PROPERTY] = this.getLineHandle(sourceLine);
      targetProperties[OFFER_PAIR_PROPERTY] = `${this.getLineHandle(sourceLine)}__${pairConfig.targetHandle}`;

      return targetProperties;
    }

    getCurrencyCode() {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: this.getCurrencyCode(),
      }).format((cents || 0) / 100);
    }

    resolveImage(product) {
      if (product.featured_image && product.featured_image.url) return product.featured_image.url;
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (Array.isArray(product.images) && product.images.length) {
        const firstImage = product.images[0];
        return typeof firstImage === 'string' ? firstImage : firstImage.src || firstImage.url || '';
      }
      return '';
    }

    /* ── Label preview rendering (JS-side, for cross-sell) ── */

    renderLabelPreviewHtml(targetProduct, targetVariant, properties) {
      let label_name = '';
      let label_line2 = '';
      let label_emoji_value = '';
      let label_font = '';
      let label_forme_raw = 'rectangle';

      for (let p in properties) {
        const title = this.normalizeValue(p);
        if (title === 'prenom nom' || title === 'premiere ligne') label_name = properties[p];
        if (title === 'deuxieme ligne') label_line2 = properties[p];
        if (title === 'emoji') label_emoji_value = properties[p];
        if (title === 'police') label_font = properties[p];
        if (title === 'forme') label_forme_raw = this.normalizeValue(properties[p]);
      }

      let label_forme = 'rectangle';
      if (label_forme_raw.includes('rond') || label_forme_raw.includes('circle')) label_forme = 'rond';
      else if (label_forme_raw.includes('carre') || label_forme_raw.includes('square')) label_forme = 'carre';

      let label_bg_color = '';
      let label_text_color = '';
      let label_quantity = '';
      
      const optionsArray = targetProduct.options || [];
      optionsArray.forEach((opt, idx) => {
        const name = this.normalizeValue(opt.name || opt);
        const val = (targetVariant.options && targetVariant.options[idx]) || targetVariant[`option${idx + 1}`] || '';
        if (name.includes('fond')) label_bg_color = val;
        else if (name.includes('criture')) label_text_color = val;
        else if (name.includes('quantite')) label_quantity = val;
      });

      const colorMap = {
        'blanc': '#FFFFFF', 'noir': '#000000', 'bleu': '#318CE7', 'vert': '#008000',
        'rouge': '#FF0000', 'violet': '#bf1cff', 'rose': '#FF69B4', 'jaune': '#FFD700',
        'orange': '#FF8C00', 'gris': '#808080'
      };

      let bg_hex = colorMap[this.normalizeValue(label_bg_color)] || '#FFFFFF';
      let text_hex = colorMap[this.normalizeValue(label_text_color)] || '#FF0000';

      if (bg_hex === '#000000' && text_hex === '#000000') text_hex = '#FFFFFF';
      if (bg_hex === '#FFFFFF' && text_hex === '#FFFFFF') text_hex = '#000000';

      let font_css = "'Myriad Pro', sans-serif";
      const font = label_font.toLowerCase();
      if (font.includes('impact')) font_css = "'Impact', sans-serif";
      else if (font.includes('georgia')) font_css = "'Georgia', serif";
      else if (font.includes('cambria')) font_css = "'Georgia', serif";
      else if (font.includes('haetten')) font_css = "'Haettenschweiler', sans-serif";
      else if (font.includes('tw cen')) font_css = "'Tw Cen MT', sans-serif";

      let border_hex = bg_hex === '#FFFFFF' ? '#dddddd' : bg_hex;

      let has_emoji = false;
      let emoji_url = '';
      if (label_emoji_value && label_emoji_value !== 'Sans') {
        has_emoji = true;
        emoji_url = this.normalizeValue(label_emoji_value).replace(/\s|-/g, '_').replace(/'/g, '_') + '.png';
      }

      const unique_id = Math.random().toString(36).substr(2, 9);
      const isMyriad = font.includes('myriad') ? 'myriad-pro' : '';

      let shapeHtml = '';
      if (label_forme === 'rectangle') {
        shapeHtml = `
          <div class="cart-item-label-preview__rect">
            ${has_emoji ? `<img src="https://cdn.shopify.com/s/files/1/0832/6329/1737/files/${emoji_url}" alt="${label_emoji_value}" class="cart-item-label-preview__emoji" loading="lazy" onerror="this.style.display='none'">` : ''}
            <span class="cart-item-label-preview__text">${this.escapeHtml(label_name)}</span>
            ${has_emoji ? `<img src="https://cdn.shopify.com/s/files/1/0832/6329/1737/files/${emoji_url}" alt="${label_emoji_value}" class="cart-item-label-preview__emoji" loading="lazy" onerror="this.style.display='none'">` : ''}
          </div>`;
      } else if (label_forme === 'carre') {
        shapeHtml = `
          <div class="cart-item-label-preview__square ${!has_emoji ? 'no-emoji' : ''}">
            ${has_emoji ? `<img src="https://cdn.shopify.com/s/files/1/0832/6329/1737/files/${emoji_url}" alt="${label_emoji_value}" class="cart-item-label-preview__emoji-square" loading="lazy" onerror="this.style.display='none'">` : ''}
            <div class="cart-item-label-preview__square-lines">
              <div class="cart-item-label-preview__line">${this.escapeHtml(label_name)}</div>
              ${label_line2 ? `<div class="cart-item-label-preview__line">${this.escapeHtml(label_line2)}</div>` : ''}
            </div>
          </div>`;
      } else if (label_forme === 'rond') {
        shapeHtml = `
          <div class="cart-item-label-preview__circle">
            ${has_emoji ? `<img src="https://cdn.shopify.com/s/files/1/0832/6329/1737/files/${emoji_url}" alt="${label_emoji_value}" class="cart-item-label-preview__emoji-circle" loading="lazy" onerror="this.style.display='none'">` : ''}
            <svg class="cart-item-label-preview__circle-svg" viewBox="0 0 200 200" aria-hidden="true">
              <defs>
                <path id="topArc-${unique_id}" d="M 15,100 A 85,85 0 0,1 185,100" />
                <path id="bottomArc-${unique_id}" d="M 15,100 A 85,85 0 0,0 185,100" />
              </defs>
              <text class="cart-item-label-preview__circle-text">
                <textPath href="#topArc-${unique_id}" startOffset="50%" text-anchor="middle" dy="-6">${this.escapeHtml(label_name)}</textPath>
              </text>
              ${label_line2 ? `
              <text class="cart-item-label-preview__circle-text">
                <textPath href="#bottomArc-${unique_id}" startOffset="50%" text-anchor="middle" dy="18">${this.escapeHtml(label_line2)}</textPath>
              </text>` : ''}
            </svg>
          </div>`;
      }

      return `
        <div class="cart-item-label-wrapper" style="margin-left: 0; margin-right: 0;">
          ${label_quantity ? `<div class="cart-item-label-qty">${label_quantity}<span class="cart-item-label-qty-x">x</span></div>` : ''}
          <div class="cart-item-label-preview cart-item-label-preview--${label_forme} ${isMyriad}"
               style="--bg-color: ${bg_hex}; --text-color: ${text_hex}; --font-family: ${font_css}; --border-color: ${border_hex};">
            ${shapeHtml}
          </div>
        </div>
      `;
    }

    /* ── Duo card markup (new cart-notification design) ── */

    /* Prix de l'offre : réduction duo appliquée aux autocollants proposés */
    offerPricing(offer) {
      const { pairConfig, targetProduct, targetVariant, sourceLine } = offer;
      const price = targetVariant.price || targetProduct.price || 0;
      const discountPct = this.getDiscountPercentage(this.extractQuantity(sourceLine.variant_title));
      const targetIsAuto = pairConfig.targetHandle === 'etiquettes-autocollantes-personnalisables';
      const sourceIsAuto = this.getLineHandle(sourceLine) === 'etiquettes-autocollantes-personnalisables';
      const hasDiscount = discountPct > 0 && targetIsAuto;
      const finalPrice = hasDiscount ? Math.max(0, price - Math.round((price * discountPct) / 100)) : price;
      return { price, finalPrice, discountPct, hasDiscount, sourceDiscount: discountPct > 0 && sourceIsAuto };
    }

    offerButtonLabel(offer) {
      const { finalPrice } = this.offerPricing(offer);
      // « assortis » masqué sur mobile pour garder le bouton sur une ligne
      const label = this.escapeHtml(offer.pairConfig.offerLabel).replace(/ (assortis)$/, '<span class="pmn-cn-offer__opt"> $1</span>');
      return `<span>${label}</span><span class="pmn-cn-offer__button-price">· ${this.formatMoney(finalPrice)}</span>`;
    }

    renderDuoCardMarkup(offer) {
      const { pairConfig, targetProduct, targetVariant, sourceLine } = offer;
      const { price, finalPrice, discountPct, hasDiscount, sourceDiscount } = this.offerPricing(offer);
      const targetTitle = targetProduct.title || pairConfig.offerLabel;
      const targetUrl = `${ROOT}products/${pairConfig.targetHandle}`;
      const customPreviewHtml = this.renderLabelPreviewHtml(targetProduct, targetVariant, this.buildTargetProperties(sourceLine, pairConfig));
      const image = this.resolveImage(targetProduct);
      const qty = this.extractQuantity(targetVariant.title);
      const badgeText = discountPct > 0 ? pairConfig.badge : 'Duo assorti';
      const kicker = pairConfig.targetHandle === 'etiquettes-autocollantes-personnalisables'
        ? 'Les mêmes, pour les objets'
        : 'Les mêmes, pour les vêtements';

      let note = `Même personnalisation${qty ? `<span class="pmn-cn-offer__qty"> · ${qty} étiquettes</span>` : ''}`;
      if (sourceDiscount) note += `<span class="pmn-cn-offer__extra"><br><strong>-${discountPct}% sur vos autocollants</strong> avec ce duo</span>`;

      return `
        <div class="pmn-cn-offer__head">
          <span class="pmn-cn-offer__badge">${this.escapeHtml(badgeText)}</span>
          <p class="pmn-cn-offer__kicker">${kicker}</p>
        </div>
        <div class="pmn-cn-offer__body">
          ${image ? `<img class="pmn-cn-offer__img" src="${this.escapeHtml(image)}" alt="" width="64" height="64">` : ''}
          <div class="pmn-cn-offer__info">
            <a class="pmn-cn-offer__title" href="${this.escapeHtml(targetUrl)}"><span class="pmn-cn-offer__full">${this.escapeHtml(targetTitle)}</span><span class="pmn-cn-offer__short">${this.escapeHtml(pairConfig.shortTitle || targetTitle)}</span></a>
            <p class="pmn-cn-offer__price">
              ${hasDiscount
                ? `<s>${this.formatMoney(price)}</s><strong>${this.formatMoney(finalPrice)}</strong><span class="pmn-cn-offer__pct">-${discountPct}%</span>`
                : `<span>${this.formatMoney(price)}</span>`}
            </p>
            <p class="pmn-cn-offer__note">${note}</p>
          </div>
        </div>
        <div class="pmn-cn-offer__preview">${customPreviewHtml}</div>
      `;
    }

    renderLegacyMarkup(offer) {
      const { sourceLine, pairConfig, targetProduct, targetVariant } = offer;
      const calcQuantity = 1; // Toujours proposer à l'unité dans l'interface
      const targetPrice = targetVariant.price || targetProduct.price || 0;
      const regularLinePrice = targetPrice * calcQuantity;
      const targetTitle = targetProduct.title || pairConfig.offerLabel;
      const targetUrl = `${ROOT}products/${pairConfig.targetHandle}`;
      const customPreviewHtml = this.renderLabelPreviewHtml(targetProduct, targetVariant, this.buildTargetProperties(sourceLine, pairConfig));
      const image = this.resolveImage(targetProduct);

      const extractQty = (str) => { const m = String(str || '').match(/\d+/); return m ? m[0] : ''; };
      const rawSourceQty = extractQty(sourceLine.variant_title);
      const discountPct = this.getDiscountPercentage(rawSourceQty);

      const targetIsAuto = pairConfig.targetHandle === 'etiquettes-autocollantes-personnalisables';
      const hasDuoDiscount = discountPct > 0;
      let discountedPrice = regularLinePrice;
      let hasDiscount = false;

      if (hasDuoDiscount && targetIsAuto) {
        hasDiscount = true;
        const autoPrice = targetPrice;
        const discountValue = Math.round((autoPrice * discountPct) / 100);
        discountedPrice = Math.max(0, regularLinePrice - discountValue);
      }

      const badgeText = hasDuoDiscount ? pairConfig.badge : 'Duo assorti';

      return `
        <div class="cart-drawer__offer">
          <div class="cart-drawer__offer-image-wrapper global-media-settings">
            <img class="cart-drawer__offer-image" src="${image || ''}" alt="${this.escapeHtml(targetTitle)}" width="70" height="70" loading="lazy">
          </div>
          <div class="cart-drawer__offer-content">
            <div class="cart-drawer__offer-badge-wrapper">
              <span class="cart-drawer__offer-badge">${this.escapeHtml(badgeText)}</span>
            </div>
            <h3 class="cart-drawer__offer-title"><a class="cart-drawer__offer-title-link" href="${this.escapeHtml(targetUrl)}">${this.escapeHtml(targetTitle)}</a></h3>

            <div class="cart-drawer__offer-meta">
              ${hasDiscount ? `
              <span class="cart-drawer__offer-price" style="display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap;">
                <s style="opacity: 0.55; font-size: 1.15rem;">${this.formatMoney(regularLinePrice)}</s>
                <span style="color: #D32F2F;">${this.formatMoney(discountedPrice)}</span>
                <span style="background: #FDEAEA; color: #D32F2F; font-size: 1.05rem; font-weight: 700; padding: 0.15rem 0.5rem; border-radius: 0.4rem;">-${discountPct}%</span>
              </span>
              ` : `
              <span class="cart-drawer__offer-price">${this.formatMoney(regularLinePrice)}</span>
              `}
              <span class="cart-drawer__offer-price" style="margin-left: 0.8rem; font-weight: normal; opacity: 0.65;">Même personnalisation</span>
            </div>
          </div>

          <div class="cart-drawer__offer-preview" style="grid-column: 1 / 3; display: flex; justify-content: center; margin: 1rem 0;">
            ${customPreviewHtml}
          </div>

          <div class="cart-drawer__offer-actions">
            <button
              type="button"
              class="button button--primary cart-drawer__offer-button"
              data-cross-sell-add
              data-source-key="${this.escapeHtml(sourceLine.key)}"
            >
              ${this.escapeHtml(pairConfig.offerLabel)}
            </button>
            <div class="cart-drawer__offer-error" data-cross-sell-error hidden></div>
          </div>
        </div>
      `;
    }

    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /* ── Add to cart handler ── */

    async handleDocumentClick(event) {
      const button = event.target.closest('[data-cross-sell-add]');
      if (!button) return;

      event.preventDefault();

      if (button.disabled) return;

      const errorNode = button.closest('.pmn-cn-offer__cta, .cart-notification__cross-sell-cta, .cart-drawer__offer-actions, .cart-drawer__offer')
        ?.querySelector('[data-cross-sell-error]');
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = '';
      }

      button.disabled = true;
      const originalLabel = button.innerHTML;
      button.textContent = 'Ajout en cours…';

      try {
        const cart = await this.fetchCart();
        const sourceKey = button.dataset.sourceKey;
        const sourceLine = (cart.items || []).find((item) => item.key === sourceKey);
        if (!sourceLine) {
          throw new Error('Ligne source introuvable dans le panier.');
        }

        const sourceHandle = this.getLineHandle(sourceLine);
        const pairConfig = PAIRS[sourceHandle];
        if (!pairConfig) {
          throw new Error('Configuration du cross-sell introuvable.');
        }

        const targetProduct = await this.fetchProduct(pairConfig.targetHandle);
        const targetVariant = this.findBestVariantMatch(targetProduct, sourceLine);
        if (!targetVariant) {
          throw new Error('Aucune variante disponible pour le produit proposé.');
        }

        const targetProperties = this.buildTargetProperties(sourceLine, pairConfig);
        const cartUiHost = this.cartUiHost;
        const formData = new FormData();

        const missingQuantity = this.getMissingCrossSellQuantity(sourceLine, cart, pairConfig);
        if (missingQuantity <= 0) {
          throw new Error('L\'offre a déjà été entièrement ajoutée pour cet article.');
        }

        formData.append('id', targetVariant.id);
        formData.append('quantity', '1'); // Toujours ajouter 1 unité par clic par sécurité

        Object.entries(targetProperties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });

        if (cartUiHost && typeof cartUiHost.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartUiHost.getSectionsToRender().map((section) => section.id).join(',')
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof cartUiHost.setActiveElement === 'function') {
            cartUiHost.setActiveElement(document.activeElement);
          }
        }

        const config = typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : { method: 'POST', headers: { Accept: 'application/javascript' } };

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        const response = await fetch(window.routes.cart_add_url, config);
        const parsedResponse = await response.json();

        if (!response.ok || parsedResponse.status) {
          throw new Error(parsedResponse.description || parsedResponse.message || 'Impossible d\'ajouter le produit suggéré.');
        }

        if (cartUiHost && parsedResponse.sections) {
          if (cartUiHost.tagName === 'CART-NOTIFICATION') {
            const sectionsToRender = cartUiHost.getSectionsToRender ? cartUiHost.getSectionsToRender() : [];
            sectionsToRender.forEach((section) => {
              const element = document.getElementById(section.id);
              if (!element || !parsedResponse.sections[section.id]) return;

              const dom = new DOMParser().parseFromString(parsedResponse.sections[section.id], 'text/html');

              if (section.id === 'cart-notification-product') {
                // Keep the existing product card, no need to replace it
                // The product card stays with the original item
              } else {
                let innerHTML = '';
                const wrapper = dom.querySelector(section.selector || '.shopify-section');
                if (wrapper) {
                  innerHTML = wrapper.innerHTML;
                } else if (dom.body.firstElementChild) {
                  innerHTML = dom.body.firstElementChild.innerHTML;
                } else {
                  innerHTML = parsedResponse.sections[section.id];
                }
                element.innerHTML = innerHTML;
              }
            });

            if (cartUiHost.header) cartUiHost.header.reveal();
            cartUiHost.open();
            document.dispatchEvent(new CustomEvent('cart-notification:opened', { detail: { key: parsedResponse.key, source: 'cart-cross-sell' } }));
          } else if (typeof cartUiHost.renderContents === 'function') {
            cartUiHost.renderContents(parsedResponse);
          }
        } else {
          window.location.href = window.routes.cart_url;
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-cross-sell',
            productVariantId: targetVariant.id,
            cartData: parsedResponse,
          });
        }
        
        // Transform the cross-sell UI to "Added" state after successful add
        this.markOfferAsAdded();

      } catch (error) {
        console.error('PrintMyName cross-sell add failed:', error);
        button.disabled = false;
        button.innerHTML = originalLabel;

        if (errorNode) {
          errorNode.hidden = false;
          errorNode.textContent = error.message || 'Impossible d\'ajouter cette offre pour le moment.';
        }

        return;
      }

      button.textContent = 'Ajouté ✓';
    }
  }

  /* ── Ajouter le même article avec un autre prénom ──
     Reprend la variante et toutes les options de l'article ajouté ; seuls les textes changent. */
  const TEXT_KEY = /(?:^|·\s*)(prénom nom|première ligne|deuxième ligne|texte|ligne 1|ligne 2)$/i;
  const SECOND_KEY = /(?:^|·\s*)(deuxième ligne|ligne 2)$/i;
  const EMOJI_CHARS = /(©|®|[ -㌀]|\ud83c[퀀-\udfff]|\ud83d[퀀-\udfff]|\ud83e[퀀-\udfff])/g;

  class PmnAgain {
    constructor() {
      this.flash = '';
      this.key = null;
    }

    get box() {
      return document.querySelector('[data-pmn-again]');
    }

    init() {
      document.addEventListener('cart-notification:opened', (event) => {
        const detail = (event && event.detail) || {};
        // Offre duo acceptée : on garde le formulaire de l'article d'origine
        if (detail.source === 'cart-cross-sell') return;
        this.render(detail.key || null);
      });

      // Page panier : bouton « Autre prénom » de chaque ligne
      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-pmn-again-line]');
        if (!button) return;
        event.preventDefault();
        this.toggleLine(button);
      });
    }

    textFields(item) {
      const props = item.properties || {};
      const forme = Object.keys(props).find((k) => k.trim().toLowerCase() === 'forme');
      const formeTwoLines = forme && /rond|carr/i.test(String(props[forme]));
      const fields = [];
      Object.keys(props).forEach((rawKey) => {
        const key = rawKey.trim();
        const value = String(props[rawKey] || '').trim();
        if (!value || key.startsWith('_') || !TEXT_KEY.test(key)) return;
        const second = SECOND_KEY.test(key);
        const max = second || /ligne [12]$/i.test(key) || formeTwoLines ? 15 : 25;
        const existing = fields.find((f) => f.value === value);
        if (existing) {
          existing.max = Math.min(existing.max, max);
          existing.second = existing.second && second;
          return;
        }
        fields.push({ value, max, second });
      });
      // Premières lignes d'abord
      return fields.sort((a, b) => Number(a.second) - Number(b.second));
    }

    async fetchItem(key) {
      try {
        const cart = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        return (cart.items || []).find((i) => i.key === key) || null;
      } catch (e) {
        return null;
      }
    }

    /* Fenêtre « Ajouté au panier » */
    async render(key) {
      const box = this.box;
      if (!box) return;
      if (!key) { box.hidden = true; return; }
      this.key = key;
      const item = await this.fetchItem(key);
      if (this.key !== key) return;
      box.hidden = !(item && this.mount(box, item, 'notification'));
    }

    /* Page panier : ouvre / ferme le formulaire sous la ligne */
    async toggleLine(button) {
      const row = button.closest('.cart-item');
      const panel = row && row.querySelector('[data-pmn-again-panel]');
      if (!panel) return;
      if (!panel.hidden) {
        panel.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        return;
      }
      const item = await this.fetchItem(button.dataset.pmnAgainLine);
      if (!item || !this.mount(panel, item, 'cart')) return;
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      const input = panel.querySelector('.pmn-cn-again__input');
      if (input) input.focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    mount(box, item, mode) {
      const fields = this.textFields(item);
      if (!fields.length) return false;

      const esc = (v) => String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      const labels = fields.length === 1 ? [''] : fields.map((f, i) => (fields.length === 2 ? `Ligne ${i + 1}` : `Texte ${i + 1}`));
      const price = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      }).format((item.price || 0) / 100);

      box.innerHTML = `
        <p class="pmn-cn-again__title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.8-3.6 3.4-5.5 6.5-5.5s5.7 1.9 6.5 5.5"/><path d="M19 8v6M16 11h6"/></svg>
          Un autre prénom ?
        </p>
        <p class="pmn-cn-again__sub">Mêmes options, il suffit de changer le texte.</p>
        <div class="pmn-cn-again__form${fields.length > 1 ? ' is-multi' : ''}" role="group">
          <div class="pmn-cn-again__fields">
            ${fields.map((f, i) => `
              <label class="pmn-cn-again__field">
                ${labels[i] ? `<span>${labels[i]}</span>` : ''}
                <input class="pmn-cn-again__input" type="text" value="${esc(f.value)}" data-old="${esc(f.value)}"
                  maxlength="${Math.max(f.max, f.value.length)}" autocomplete="off" autocapitalize="words" spellcheck="false" enterkeyhint="done"
                  aria-label="${labels[i] || 'Nouveau texte de l’étiquette'}">
              </label>`).join('')}
          </div>
          <button type="button" class="pmn-cn-again__button" disabled>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
            Ajouter<span class="pmn-cn-again__price"> · ${price}</span>
          </button>
        </div>
        <p class="pmn-cn-again__msg" aria-live="polite">${mode === 'notification' ? this.flash : ''}</p>
      `;
      if (mode === 'notification') this.flash = '';

      const inputs = Array.from(box.querySelectorAll('.pmn-cn-again__input'));
      const button = box.querySelector('.pmn-cn-again__button');
      const msg = box.querySelector('.pmn-cn-again__msg');
      const refresh = () => {
        const changed = inputs.some((input) => input.value.trim() !== input.dataset.old);
        button.disabled = !changed || !inputs[0].value.trim();
      };
      inputs.forEach((input) => {
        input.addEventListener('input', () => {
          const clean = input.value.replace(EMOJI_CHARS, '');
          if (clean !== input.value) input.value = clean;
          refresh();
        });
        // On garde généralement le nom de famille : le prénom (premier mot) est sélectionné au premier clic
        input.addEventListener('focus', () => {
          if (input.value !== input.dataset.old) return;
          const space = input.value.indexOf(' ');
          setTimeout(() => input.setSelectionRange(0, space > 0 ? space : input.value.length), 0);
        }, { once: true });
      });
      // Pas de <form> : sur la page panier, le bloc est déjà dans le formulaire du panier
      const submit = () => { if (!button.disabled) this.add(item, inputs, button, msg, mode); };
      button.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); submit(); });
      inputs.forEach((input) => input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        submit();
      }));
      return true;
    }

    async add(item, inputs, button, msg, mode) {
      const replacements = new Map(inputs.map((input) => [input.dataset.old, input.value.replace(/\s+/g, ' ').trim()]));
      const label = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Ajout…';
      msg.textContent = '';
      msg.classList.remove('is-error');

      const notification = document.querySelector('cart-notification');
      const cartItems = mode === 'cart' ? document.querySelector('cart-items') : null;
      const host = mode === 'cart' ? cartItems : notification;
      const formData = new FormData();
      formData.append('id', item.variant_id);
      formData.append('quantity', '1');
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') return;
        if (String(key).startsWith('_cross_sell')) return;
        const text = String(value).trim();
        const next = TEXT_KEY.test(key.trim()) && replacements.has(text) ? replacements.get(text) : value;
        if (next === '') return;
        formData.append(`properties[${key}]`, next);
      });
      const sections = host && typeof host.getSectionsToRender === 'function' ? host.getSectionsToRender() : [];
      if (sections.length) {
        formData.append('sections', sections.map((s) => s.section || s.id).join(','));
        formData.append('sections_url', window.location.pathname);
      }

      try {
        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
        const response = await fetch(window.routes.cart_add_url, config);
        const parsed = await response.json();
        if (!response.ok || parsed.status) throw new Error(parsed.description || parsed.message || 'Ajout impossible.');

        const name = inputs.map((input) => input.value.trim()).filter(Boolean).join(' ');
        const done = `✓ « ${name.replace(/&/g, '&amp;').replace(/</g, '&lt;')} » a bien été ajouté au panier.`;

        if (mode === 'cart') {
          this.renderCart(cartItems, sections, parsed, done);
          return;
        }

        this.flash = done;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pmn-again', productVariantId: item.variant_id, cartData: parsed });
        }
        if (notification && parsed.sections && typeof notification.renderContents === 'function') {
          notification.renderContents(parsed);
          const body = document.querySelector('.pmn-cn__body');
          if (body) body.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          window.location.href = window.routes.cart_url;
        }
      } catch (error) {
        console.error('PMN autre prénom :', error);
        this.flash = '';
        button.innerHTML = label;
        button.disabled = false;
        msg.classList.add('is-error');
        msg.textContent = error.message || 'Ajout impossible pour le moment.';
      }
    }

    /* Page panier : on ré-affiche les lignes et le récapitulatif, puis on montre la nouvelle ligne */
    renderCart(cartItems, sections, parsed, done) {
      if (!cartItems || !parsed.sections) {
        window.location.reload();
        return;
      }
      sections.forEach((section) => {
        const html = parsed.sections[section.section];
        const holder = document.getElementById(section.id);
        if (!html || !holder) return;
        const target = holder.querySelector(section.selector) || holder;
        target.innerHTML = cartItems.getSectionInnerHTML(html, section.selector);
      });
      const link = document.querySelector(`cart-items a.pmn-cart-edit[href*="pmn_edit=${encodeURIComponent(parsed.key)}"]`);
      const row = link && link.closest('.cart-item');
      if (!row) return;
      row.classList.add('pmn-cart-item--new');
      const note = document.createElement('p');
      note.className = 'pmn-cart-item__added';
      note.setAttribute('role', 'status');
      note.innerHTML = done;
      row.appendChild(note);
      const header = document.querySelector('.header-wrapper');
      const offset = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      window.scrollTo({ top: window.scrollY + row.getBoundingClientRect().top - offset - 16, behavior: 'smooth' });
      setTimeout(() => row.classList.remove('pmn-cart-item--new'), 2400);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.PrintMyNameCrossSell = new PrintMyNameCrossSell();
    window.PrintMyNameCrossSell.init();
    window.PMNAgain = new PmnAgain();
    window.PMNAgain.init();
  });
})();
